import { render } from "./SuccessLog.vue?vue&type=template&id=65a7896e"
import script from "./SuccessLog.vue?vue&type=script&lang=js"
export * from "./SuccessLog.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Project\\远创人力\\开发\\前端\\yc_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__